export enum WizardProgress {
  START = 0,
  MIDDLE = 1,
  END = 2,
}
